import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { validateAdminCredentials } from '../../services/firebase/settingsService';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../services/firebase/config';

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const getFriendlyError = (errMessage) => {
    if (!errMessage) return 'Invalid username or password.';
    return errMessage;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const user = await validateAdminCredentials(credentials.username, credentials.password);

      if (user) {
        // Also sign in with Firebase Auth so Firestore security rules are satisfied.
        // The admin user record has an email and the Firebase Auth password
        // matches the admin password stored in Firestore.
        if (user.email) {
          try {
            await signInWithEmailAndPassword(auth, user.email, credentials.password);
          } catch (authErr) {
            console.warn('Firebase Auth sign-in failed (writes may be rejected by security rules):', authErr.code);
            // Don't block login – the custom validation already passed.
            // Firestore rules that require auth will still fail, but at least
            // the admin can view data.
          }
        }

        // Persist admin session and user info for ProtectedRoute and AdminLayout
        localStorage.setItem('adminLoggedIn', 'true');
        localStorage.setItem('adminUser', JSON.stringify(user));

        navigate('/admin/dashboard');
      } else {
        setError('Invalid username or password');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(getFriendlyError(error?.message));
    }
  };

  return (
    <section className="page-section">
      <Container>
        <Row className="justify-content-center">
          <Col md={6}>
            <div className="bg-white p-4 shadow-sm rounded">
              <h2 className="text-center mb-4">Admin Login</h2>
              {error && <Alert variant="danger">{error}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    value={credentials.username}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      value={credentials.password}
                      onChange={handleChange}
                      required
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowPassword((prev) => !prev)}
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                    >
                      {showPassword ? 'Hide' : 'Show'}
                    </Button>
                  </InputGroup>
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100">
                  Login
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AdminLogin;
